<template>
  <v-container>
    <v-card>
      <v-container>
        <h1>Change Log</h1>
        <p>All notable changes to this project will be documented in this file. Changes include Web App, Nodes and serverside code</p>
        <h2>[Unreleased]</h2>
        <!-- <h3>Added</h3>
        <ul>
          <li><strong>Web App</strong> Add total number of staff onsite to main view</li>
        </ul>
        <ul>
          <li><strong>Web App</strong> Add emergency screen</li>
        </ul>
        <br> -->
        <h2>1.0.12 - 13/3/2019</h2>
        <h3>Added</h3>
        <ul>
          <li><strong>Web App</strong> Ability to persist emergency data and close the event</li>
        </ul>
        <br>
        <v-divider></v-divider>
        <h2>1.0.11 - 12/3/2019</h2>
        <h3>Added</h3>
        <ul>
          <li><strong>Web App</strong> Updated visuals and added onsight logo</li>
        </ul>
        <br>
        <v-divider></v-divider>
        <h2>1.0.10 - 11/3/2019</h2>
        <h3>Added</h3>
        <ul>
          <li><strong>Web App</strong> Moved time updated to be optional in main screen, now toggled in filter button</li>
          <li><strong>Web App</strong> Added blue to the status of being onsite on the main page</li>
          <li><strong>Web App</strong> Added ability to hide users on the main screen from user editing page</li>
        </ul>
        <br>
        <h2>1.0.9 - 8/3/2019</h2>
        <h3>Fixed</h3>
        <ul>
          <li><strong>Web App</strong> Safaris and iOs issue with the user logs screen</li>
        </ul>
        <h2>1.0.9 - 21/11/2018</h2>
        <h3>Added</h3>
        <ul>
          <li><strong>Web App</strong> Added emergency page to the site</li>
        </ul>
        <h2>1.0.8 - 21/11/2018</h2>
        <h3>Added</h3>
        <ul>
          <li><strong>Web App</strong> Added Card info to the site</li>
          <li><strong>Web App</strong> Added ability to filter out blank cards</li>
        </ul>
        <br>
        <h2>1.0.7 - 20/11/2018</h2>
        <h3>Changed</h3>
        <ul>
          <li><strong>Web App</strong> Added admin ability to add cards to web application</li>
        </ul>
        <br>
        <h2>1.0.6 - 19/11/2018</h2>
        <h3>Changed</h3>
        <ul>
          <li><strong>Web App</strong> Added filter button to main screen</li>
        </ul>
        <br>
        <h2>1.0.5 - 31/10/2018</h2>
        <h3>Changed</h3>
        <ul>
          <li><strong>Web App</strong> Increased default pagination on main screen</li>
        </ul>
        <h2>1.0.4 - 26/10/2018</h2>
        <h3>Changed</h3>
        <ul>
          <li><strong>Web App</strong> Added the ability to select a day in the user logs</li>
        </ul>
        <h2>1.0.3 - 20/10/2018</h2>
        <h3>Changed</h3>
        <ul>
          <li><strong>Server</strong> Reduced update rate for any ID to no more than 2 seconds</li>
        </ul>
        <h2>1.0.2 - 18/10/2018</h2>
        <h3>Added</h3>
        <ul>
          <li><strong>Web App</strong> Added a changelog to track changes</li>
        </ul>
        <h3>Changed</h3>
        <ul>
          <li><strong>Web App</strong> After typing password, hitting enter will also log you in</li>
          <li><strong>Web App</strong> Reduced user log table to only display 25 results. Temporary fix until date filtering can be implemented</li>
          <li><strong>Nodes</strong> Changed range from all RSSI to anything above -92</li>
          <li><strong>Server</strong> Fixed a database read error where the server was quering the database multiple times</li>
          <li><strong>Server</strong> Lowered the update rate to the database</li>
        </ul>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Changes.vue